import { render, staticRenderFns } from "./ListsCollectLists.vue?vue&type=template&id=09cf9002&scoped=true&"
import script from "./ListsCollectLists.vue?vue&type=script&lang=js&"
export * from "./ListsCollectLists.vue?vue&type=script&lang=js&"
import style0 from "./ListsCollectLists.vue?vue&type=style&index=0&id=09cf9002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf9002",
  null
  
)

export default component.exports